import { getOpeningHoursForDate } from '@/lib/helpers/OpeningHours.js'
import { formatRange } from '@/lib/helpers/HoursFormatter.js'
import moment from 'moment'

const startDayHourMs = 0
const endDayHourMs = 86399999

export default {
  methods: {
    getWeekTimeTable (openingHours) {
      // con el día de la semana obtener el working hours que corresponda y los rangos de horas
      const openingHoursByDay = []
      // por cada día de la semana
      for (let dayMoment = moment().startOf('week').add(1, 'ms'); openingHoursByDay.length < 7; dayMoment.add(1, 'day')) {
        const chosenWorkingHour = getOpeningHoursForDate(dayMoment, openingHours)
        let availableHours = chosenWorkingHour ? this.joinOvernight(chosenWorkingHour).filter((ah) => {
          return (ah.dow === dayMoment.day())
        }) : []
        openingHoursByDay.push({
          day: dayMoment.day(),
          hours: availableHours.sort((a, b) => {
            return a.startHour - b.startHour
          }),
          current: dayMoment.day() === moment().day(),
        })
      }
      return openingHoursByDay
    },
    joinOvernight (openingHours) {
      const res = []
      openingHours.availableHours.forEach(aH => {
        const startingPart = this.findStartingPart(aH, openingHours)
        const endingPart = this.findEndingPart(aH, openingHours)
        if (aH.endHour === endDayHourMs && endingPart) {
          res.push({ ...aH, endHour: endingPart.endHour })
        } else if (!startingPart) {
          res.push(aH)
        }
      })
      return res
    },
    findStartingPart (aH, openingHours) {
      if (aH.startHour === startDayHourMs) {
        const a = openingHours.availableHours
        return a.find(o => o.dow === ((aH.dow - 1 >= 0) ? aH.dow - 1 : 6) && o.endHour === endDayHourMs)
      }
    },
    findEndingPart (aH, openingHours) {
      if (aH.endHour === endDayHourMs) {
        const a = openingHours.availableHours
        return a.find(o => o.dow === ((aH.dow + 1 < 7) ? aH.dow + 1 : 0) && o.startHour === startDayHourMs)
      }
    },
    getCurrent () {
      const now = moment()
      this.timetable.forEach((item) => {
        item.hours.forEach((hour) => {
          if (hour.dow === now.day()) {
            var start = moment().startOf('day').add(hour.startHour, 'ms')
            var end = moment().startOf('day').add(hour.endHour, 'ms')
            if (now.isAfter(start) && now.isBefore(end)) {
              item.current = true
              this.current = formatRange(hour)
            }
          }
        })
      })
    },
  },
}
